import React from "react";
import Show from "../../utils/show.component";

const determineButtonClass = (currentPaymentType, paymentType, disabled) => {
  if (disabled) {
    return "button disabled";
  }
  return currentPaymentType == paymentType ? "button active" : "button";
};

const PaymentTypeButtonBar = ({
  changePaymentType,
  currentPaymentType,
  achAllowed,
  ChargeOffIsRequired,
  achNotAllowedMessage
}) => (
  <Show condition={ChargeOffIsRequired !== true && achAllowed !== false}>
    <div role="group" className="btn-group">
      <button
        type="button"
        className={determineButtonClass(currentPaymentType, "debit")}
        onClick={() => changePaymentType("debit")}
        data-e2e-id="debitCardButton"
      >
        Debit Card
      </button>
      <button
        type="button"
        className={determineButtonClass(currentPaymentType, "ach", achAllowed === false)}
        onClick={() => {
            changePaymentType("ach");
        }}
        data-tip={achNotAllowedMessage}
        data-e2e-id="bankAccountButton"
      >
        Bank Account (free)
      </button>
    </div>
  </Show>
);

export default PaymentTypeButtonBar;



// WEBPACK FOOTER //
// ./src/components/payment-type-button-bar/payment-type-button-bar.component.js